var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666748 9.60417V14.7292C0.666748 15.1822 0.846733 15.6168 1.16711 15.9371C1.48748 16.2575 1.922 16.4375 2.37508 16.4375H12.6251C13.0782 16.4375 13.5127 16.2575 13.8331 15.9371C14.1534 15.6168 14.3334 15.1822 14.3334 14.7292V9.60417M7.50008 1.0625V11.3125M7.50008 11.3125L4.5105 8.32292M7.50008 11.3125L10.4897 8.32292",
    stroke: "white",
    strokeWidth: 1.13889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/Import.99f4af1cafb7cd6228cda1c5793f4732.svg";
export { ForwardRef as ReactComponent };